module.exports = __webpack_public_path__ + "static/animated-illustration-6-ddf9e3101f913af0f02d56bf6e9f9c4d.gif";